export default __webpack_public_path__ + "static/iosQrcode-2ea4cbb88e49e94021fa277899f2e712.png";